import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { SysParamDto } from 'src/app/server-api/models';
import { SysParamControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { ISystemParamFormGroup } from './ISystemParamFormGroup';

@Component({
  selector: 'app-system-param',
  templateUrl: './system-param.component.html',
  styleUrls: ['./system-param.component.css']
})
export class SystemParamComponent  extends DetailComponent {
  sysParam: SysParamDto;

  constructor(
    public override translate: TranslateService,
    private systemParamsService: SysParamControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.sysParam = {} as any as SysParamDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

    this.systemParamsService.getSysParam(request).subscribe((data: SysParamDto) => {
      this.sysParam = data;
      this.name = data.key;

      this.initForm();
      this.detailForm.controls['id'].disable();
    },
    (err: string) => {
      window.alert(err.replace('Object', 'System parameter'));
    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['id', false],
      ['key', true],
      ['value', true]
    ]);

    this.detailForm = this.formBuilder.group({
      id: [''],
      key: ['', Validators.required],
      value: ['', Validators.required]



    }) as ISystemParamFormGroup;

    //patch value dto to formGroup
    this.detailForm.patchValue(this.sysParam);
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('system-param.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu', 'icon_next', 'icon_previous']).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
          hide: false
        },
        {
          icon: 'arrow_back',
          title: translations['icon_previous'],
          routerLink: null,
          clickMethod: 'navigatePrevious',
          hide: this.hidePrevious
        },
        {
          icon: 'arrow_forward',
          title: translations['icon_next'],
          routerLink: null,
          clickMethod: 'navigateNext',
          hide: this.hideNext
        },
        {
          icon: 'menu',
          title: translations['icon_menu'],
          routerLink: RouterLinkEnum.SYSTEMPARAMS_LIST.toString(),
          clickMethod: 'dummy',
          hide: false
        },
      ];
    });
    this.setForm();
  }

  override saveOk() {
    super.saveOk();
    this.sysParam = this.detailForm.value;

    var response =
      this.id !== 'new'
        ? this.systemParamsService.updateSysParam({
            id: this.id,
            body: this.sysParam,
          })
        : this.systemParamsService.createSysParam({ body: this.sysParam });

    response.subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        if (this.id === 'new')
        {
          this.router.navigateByUrl(RouterLinkEnum.SYSTEMPARAMS.toString() + data.id);
        }
        else
        {
          this.refresh();
        }
      },
      (err) => {
        this.sidenavService.setLoading(false);
        console.log('System parameter not created/updated');
        window.alert('Create/update system parameter not possible');
      }
    );
  }


  override delete() {
    super.delete();
    this.systemParamsService.deleteSysParam({ id: this.id }).subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        this.router.navigateByUrl(RouterLinkEnum.SYSTEMPARAMS_LIST.toString());
        console.log('item deleted successfully!');
      },
      (error) => {
        this.sidenavService.setLoading(false);
        console.log(error.error.message);
        window.alert('Delete system parameter not possible');
      }
    );
  }

  //https://www.javachinna.com/angular-spring-boot-crud-app/
}


